/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as LabelDefs from '../../../com/atproto/label/defs.defs'
import * as ActorDefs from '../actor/defs.defs'
import * as RichtextFacet from '../richtext/facet.defs'
import * as FeedDefs from '../feed/defs.defs'

const $nsid = 'app.bsky.graph.defs'

type $nsid = typeof $nsid

export { $nsid }

/** A list of actors to apply an aggregate moderation action (mute/block) on. */
const modlist = /*#__PURE__*/ l.token($nsid, 'modlist')

export { modlist }

/** A list of actors to apply an aggregate moderation action (mute/block) on. */
const Modlist = /*#__PURE__*/ modlist.value

/** A list of actors to apply an aggregate moderation action (mute/block) on. */
type Modlist = typeof Modlist

export { Modlist }

type ListView = {
  $type?: 'app.bsky.graph.defs#listView'
  cid: l.CidString
  uri: l.AtUriString
  name: string
  avatar?: l.UriString
  labels?: LabelDefs.Label[]
  viewer?: ListViewerState
  creator: ActorDefs.ProfileView
  purpose: ListPurpose
  indexedAt: l.DatetimeString
  description?: string
  listItemCount?: number
  descriptionFacets?: RichtextFacet.Main[]
}

export type { ListView }

const listView = /*#__PURE__*/ l.typedObject<ListView>(
  $nsid,
  'listView',
  /*#__PURE__*/ l.object({
    cid: /*#__PURE__*/ l.string({ format: 'cid' }),
    uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    name: /*#__PURE__*/ l.string({ maxLength: 64, minLength: 1 }),
    avatar: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'uri' })),
    labels: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<LabelDefs.Label>((() => LabelDefs.label) as any),
      ),
    ),
    viewer: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ListViewerState>((() => listViewerState) as any),
    ),
    creator: /*#__PURE__*/ l.ref<ActorDefs.ProfileView>(
      (() => ActorDefs.profileView) as any,
    ),
    purpose: /*#__PURE__*/ l.ref<ListPurpose>((() => listPurpose) as any),
    indexedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    description: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxLength: 3000, maxGraphemes: 300 }),
    ),
    listItemCount: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.integer({ minimum: 0 }),
    ),
    descriptionFacets: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<RichtextFacet.Main>(
          (() => RichtextFacet.main) as any,
        ),
      ),
    ),
  }),
)

export { listView }

/** A list of actors used for curation purposes such as list feeds or interaction gating. */
const curatelist = /*#__PURE__*/ l.token($nsid, 'curatelist')

export { curatelist }

/** A list of actors used for curation purposes such as list feeds or interaction gating. */
const Curatelist = /*#__PURE__*/ curatelist.value

/** A list of actors used for curation purposes such as list feeds or interaction gating. */
type Curatelist = typeof Curatelist

export { Curatelist }

type ListPurpose =
  | 'app.bsky.graph.defs#modlist'
  | 'app.bsky.graph.defs#curatelist'
  | 'app.bsky.graph.defs#referencelist'
  | l.UnknownString

export type { ListPurpose }

const listPurpose = /*#__PURE__*/ l.string<{
  knownValues: [
    'app.bsky.graph.defs#modlist',
    'app.bsky.graph.defs#curatelist',
    'app.bsky.graph.defs#referencelist',
  ]
}>()

export { listPurpose }

type ListItemView = {
  $type?: 'app.bsky.graph.defs#listItemView'
  uri: l.AtUriString
  subject: ActorDefs.ProfileView
}

export type { ListItemView }

const listItemView = /*#__PURE__*/ l.typedObject<ListItemView>(
  $nsid,
  'listItemView',
  /*#__PURE__*/ l.object({
    uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    subject: /*#__PURE__*/ l.ref<ActorDefs.ProfileView>(
      (() => ActorDefs.profileView) as any,
    ),
  }),
)

export { listItemView }

/** lists the bi-directional graph relationships between one actor (not indicated in the object), and the target actors (the DID included in the object) */
type Relationship = {
  $type?: 'app.bsky.graph.defs#relationship'
  did: l.DidString

  /**
   * if the actor blocks this DID, this is the AT-URI of the block record
   */
  blocking?: l.AtUriString

  /**
   * if the actor is blocked by this DID, contains the AT-URI of the block record
   */
  blockedBy?: l.AtUriString

  /**
   * if the actor follows this DID, this is the AT-URI of the follow record
   */
  following?: l.AtUriString

  /**
   * if the actor is followed by this DID, contains the AT-URI of the follow record
   */
  followedBy?: l.AtUriString

  /**
   * if the actor is blocked by this DID via a block list, contains the AT-URI of the listblock record
   */
  blockedByList?: l.AtUriString

  /**
   * if the actor blocks this DID via a block list, this is the AT-URI of the listblock record
   */
  blockingByList?: l.AtUriString
}

export type { Relationship }

/** lists the bi-directional graph relationships between one actor (not indicated in the object), and the target actors (the DID included in the object) */
const relationship = /*#__PURE__*/ l.typedObject<Relationship>(
  $nsid,
  'relationship',
  /*#__PURE__*/ l.object({
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    blocking: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'at-uri' }),
    ),
    blockedBy: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'at-uri' }),
    ),
    following: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'at-uri' }),
    ),
    followedBy: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'at-uri' }),
    ),
    blockedByList: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'at-uri' }),
    ),
    blockingByList: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'at-uri' }),
    ),
  }),
)

export { relationship }

type ListViewBasic = {
  $type?: 'app.bsky.graph.defs#listViewBasic'
  cid: l.CidString
  uri: l.AtUriString
  name: string
  avatar?: l.UriString
  labels?: LabelDefs.Label[]
  viewer?: ListViewerState
  purpose: ListPurpose
  indexedAt?: l.DatetimeString
  listItemCount?: number
}

export type { ListViewBasic }

const listViewBasic = /*#__PURE__*/ l.typedObject<ListViewBasic>(
  $nsid,
  'listViewBasic',
  /*#__PURE__*/ l.object({
    cid: /*#__PURE__*/ l.string({ format: 'cid' }),
    uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    name: /*#__PURE__*/ l.string({ maxLength: 64, minLength: 1 }),
    avatar: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'uri' })),
    labels: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<LabelDefs.Label>((() => LabelDefs.label) as any),
      ),
    ),
    viewer: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ListViewerState>((() => listViewerState) as any),
    ),
    purpose: /*#__PURE__*/ l.ref<ListPurpose>((() => listPurpose) as any),
    indexedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    listItemCount: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.integer({ minimum: 0 }),
    ),
  }),
)

export { listViewBasic }

/** indicates that a handle or DID could not be resolved */
type NotFoundActor = {
  $type?: 'app.bsky.graph.defs#notFoundActor'
  actor: l.AtIdentifierString
  notFound: true
}

export type { NotFoundActor }

/** indicates that a handle or DID could not be resolved */
const notFoundActor = /*#__PURE__*/ l.typedObject<NotFoundActor>(
  $nsid,
  'notFoundActor',
  /*#__PURE__*/ l.object({
    actor: /*#__PURE__*/ l.string({ format: 'at-identifier' }),
    notFound: /*#__PURE__*/ l.literal(true),
  }),
)

export { notFoundActor }

/** A list of actors used for only for reference purposes such as within a starter pack. */
const referencelist = /*#__PURE__*/ l.token($nsid, 'referencelist')

export { referencelist }

/** A list of actors used for only for reference purposes such as within a starter pack. */
const Referencelist = /*#__PURE__*/ referencelist.value

/** A list of actors used for only for reference purposes such as within a starter pack. */
type Referencelist = typeof Referencelist

export { Referencelist }

type ListViewerState = {
  $type?: 'app.bsky.graph.defs#listViewerState'
  muted?: boolean
  blocked?: l.AtUriString
}

export type { ListViewerState }

const listViewerState = /*#__PURE__*/ l.typedObject<ListViewerState>(
  $nsid,
  'listViewerState',
  /*#__PURE__*/ l.object({
    muted: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
    blocked: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'at-uri' }),
    ),
  }),
)

export { listViewerState }

type StarterPackView = {
  $type?: 'app.bsky.graph.defs#starterPackView'
  cid: l.CidString
  uri: l.AtUriString
  list?: ListViewBasic
  feeds?: FeedDefs.GeneratorView[]
  labels?: LabelDefs.Label[]
  record: l.LexMap
  creator: ActorDefs.ProfileViewBasic
  indexedAt: l.DatetimeString
  joinedWeekCount?: number
  listItemsSample?: ListItemView[]
  joinedAllTimeCount?: number
}

export type { StarterPackView }

const starterPackView = /*#__PURE__*/ l.typedObject<StarterPackView>(
  $nsid,
  'starterPackView',
  /*#__PURE__*/ l.object({
    cid: /*#__PURE__*/ l.string({ format: 'cid' }),
    uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    list: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ListViewBasic>((() => listViewBasic) as any),
    ),
    feeds: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<FeedDefs.GeneratorView>(
          (() => FeedDefs.generatorView) as any,
        ),
        { maxLength: 3 },
      ),
    ),
    labels: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<LabelDefs.Label>((() => LabelDefs.label) as any),
      ),
    ),
    record: /*#__PURE__*/ l.lexMap(),
    creator: /*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>(
      (() => ActorDefs.profileViewBasic) as any,
    ),
    indexedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    joinedWeekCount: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.integer({ minimum: 0 }),
    ),
    listItemsSample: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<ListItemView>((() => listItemView) as any),
        { maxLength: 12 },
      ),
    ),
    joinedAllTimeCount: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.integer({ minimum: 0 }),
    ),
  }),
)

export { starterPackView }

type StarterPackViewBasic = {
  $type?: 'app.bsky.graph.defs#starterPackViewBasic'
  cid: l.CidString
  uri: l.AtUriString
  labels?: LabelDefs.Label[]
  record: l.LexMap
  creator: ActorDefs.ProfileViewBasic
  indexedAt: l.DatetimeString
  listItemCount?: number
  joinedWeekCount?: number
  joinedAllTimeCount?: number
}

export type { StarterPackViewBasic }

const starterPackViewBasic = /*#__PURE__*/ l.typedObject<StarterPackViewBasic>(
  $nsid,
  'starterPackViewBasic',
  /*#__PURE__*/ l.object({
    cid: /*#__PURE__*/ l.string({ format: 'cid' }),
    uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    labels: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<LabelDefs.Label>((() => LabelDefs.label) as any),
      ),
    ),
    record: /*#__PURE__*/ l.lexMap(),
    creator: /*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>(
      (() => ActorDefs.profileViewBasic) as any,
    ),
    indexedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    listItemCount: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.integer({ minimum: 0 }),
    ),
    joinedWeekCount: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.integer({ minimum: 0 }),
    ),
    joinedAllTimeCount: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.integer({ minimum: 0 }),
    ),
  }),
)

export { starterPackViewBasic }
